module.exports = __webpack_public_path__ + "img/dispatch.4a79d494.svg";